export enum NotificationType {
    Basic = 1,
    Link,
    Product,
    Pickup
}

export enum NotificationTargetType {
    All = 1,
    Single,
    Employee,
    Customer
}